module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAABVQTFRF+IB4SEA4gHhwkDAo8FAw+Pj4////2aLVywAAAAF0Uk5TAEDm2GYAAABoSURBVBhXXc7RCUJRDAPQCg6guEFCB7C1/4JOEOj+q8jzytOavxwaqB2fI3d75MjNZs+0zGq1SkW1FgAFuVOOBcyiwqniZ8Lt3HsHbOCOHd6T+pkwW64vBBMIBBEL/h67zH61w3nk9AICOivU7qriYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Fighting.png
// module id = 162
// module chunks = 0